import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { mockedSubcategories } from "design-spec/mock";

import { listenEventBroker, listenStoredEvents } from "features/event-driver/broker/eventBrokerSlice";
import { listenDataStore } from "features/event-driver/store/dataStoreSlice";

import { DesktopContent } from "features/UI/templates/desktop/content/DesktopContent";
import { TabletContent } from "features/UI/templates/tablet/content/TabletContent";
import { SmartphoneContent } from "features/UI/templates/smartphone/content/SmartphoneContent";

import { useMediaQuery } from "@mui/material";

import theme from "mui/theme";

import { contentStyles } from "./Content.styles";
import { useRouterFinder } from "features/utils/routes/useRouterFinder";

export function Content() {
  const classes = contentStyles();

  const desktopScreen = useMediaQuery(theme.breakpoints.only("desktop"));
  const tabletScreen = useMediaQuery(theme.breakpoints.only("tablet"));
  const smartphoneScreen = useMediaQuery(theme.breakpoints.only("smartphone"));
  
  const storedEvents = useSelector(listenStoredEvents);
  const selectedCategory = storedEvents.selectedCategory;
  const selectedSubcategory = storedEvents.selectedSubcategory;
  
  const storedData = useSelector(listenDataStore);
  const categories = storedData && storedData.categories || [];
  const allSubcategories = storedData && storedData.subcategories || [];
  const contents = storedData && storedData.subcategoriesContent || [];
  
  const [subcategories, subcategoriesSet] = useState([]);
  const loadState = useSelector(listenEventBroker);

  // const routed = useRouterFinder(loadState.state);
  
  useEffect(() => {
    const filteredSubcategories = allSubcategories.filter(
      (sub) => sub.category === selectedCategory
    );
    subcategoriesSet(filteredSubcategories);
  }, [selectedCategory]);

  const [uncategorizedContent, uncategorizedContentSet] = useState("");

  useEffect(() => {
    if (storedData) {
      uncategorizedContentSet(storedData.uncategorizedContent);
    }
  }, [storedData]);

  // console.debug(window.location)

  const cmsData = {
    categories,
    subcategories,
    selectedCategory,
    selectedSubcategory,
    contents,
    uncategorizedContent
  };

  return (
    <div className={classes.content__root}>
      {desktopScreen && <DesktopContent cmsData={cmsData} />}
      {tabletScreen && <TabletContent cmsData={cmsData} />}
      {smartphoneScreen && <SmartphoneContent cmsData={cmsData} />}
    </div>
  );
}
